import instance  from "@/api/instance";
const END_POINT = '/api';

const translate = () => instance.get(`${END_POINT}/translates`,);


export default {
    translate,
}